export enum BrandEnum {
	DeutscheFiskal = 'deutscheFiskal'
}
